import { useMemo } from 'react';
import { useMutation } from '@apollo/client';
import DATA_WAREHOUSE_IMPORT_CREATE from '../mutations/DATA_WAREHOUSE_IMPORT_CREATE';

const useDataWarehouseCreateImport = () => {
    const [ createNewImport ] = useMutation( DATA_WAREHOUSE_IMPORT_CREATE );

    const createImport = async ( saveData ) => {
        try {
            const response = await createNewImport(  { variables: { input: saveData } } );
            const success = response?.data?.createDataWarehouseImport?.length > 0;

            if ( success ) {
                return {
                    success: true,
                    response: response.data.createDataWarehouseImport
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) {
            console.error( 'Error creating import', error );
            return {
                success: false,
                response: error
            };
        }
    };

    return useMemo( () => {
        return {
            createImport
        };
    }, [] );
};

export default useDataWarehouseCreateImport;
